let state = {
  Cuentas_Usuarios_001OperadorDeSala: [],
  Cuentas_Usuarios_001Usuario: []
}

let mutations = {
  M_Cuentas_Usuarios_001OperadorDeSala(state, data) {
    state.Cuentas_Usuarios_001OperadorDeSala[data.llave] = data.valor;
  },
  M_Cuentas_Usuarios_001Usuario(state, data) {
      state.Cuentas_Usuarios_001Usuario[data.llave] = data.valor;
    }
}

let actions = {
  A_Cuentas_Usuarios_Establecer001OperadorDeSala: ({ commit }, data) => {
    commit('M_Cuentas_Usuarios_001OperadorDeSala', data);
  },
   A_Cuentas_Usuarios_Establecer001Usuario: ({ commit }, data) => {
    commit('M_Cuentas_Usuarios_001Usuario', data);
  }
}

const Cuentas = {
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default Cuentas;



// WEBPACK FOOTER //
// ./src/store/Cuentas.js